import type { OpsDashboardAlertsResponse } from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Typed wrapper around `ops-api /v1/ops/health/dashboard-alerts`.
 *
 * The endpoint fans out to gateway-worker + platform-api and merges the
 * four alert classes (`unrouted_skus`, `single_point_skus`,
 * `low_funding_upstreams`, `unhealthy_upstreams_24h`). Thresholds live
 * server-side — the client renders the returned arrays verbatim.
 *
 * This module kept separate from `routerStats.ts` because Dashboard
 * alerts and router-stats have different refresh cadences (alerts poll
 * often for the "what's on fire" feel; stats change slowly) and future
 * work may split the Dashboard into independent React Query keys with
 * different `staleTime` settings.
 */

const BASE_PATH = '/v1/ops/health/dashboard-alerts';

export async function getDashboardAlerts(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<OpsDashboardAlertsResponse> {
  return opsApiRequest<OpsDashboardAlertsResponse>(BASE_PATH, { signal }, fetchImpl);
}
